#import "../../../../../graphql/fragments/peep-legacy-id-fragment.graphql"

mutation UpdateAccountLegacyId($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...PeepLegacyIdFragment
        }
    }
}
